import { Table } from '@/components/asset_type_maintenance_schedule/table'
interface Props {
  id: string
}

export const EditMaintenance = ({ id }: Props) => {
  return (
    <Table filters={{ assetTypeIdEq: id }} createable deleteable fixedHeight />
  )
}
